import { useState } from "react";

import notification, {
    Error as notificationError,
} from "../../../modules/Notifications";

import api, { publicRequest } from "../../../service/api";

import useLoading from "../../../hooks/useLoading";

import main from "../../../service/mail";

function useContact(client) {
    const [data, setData] = useState({
        subject: "",
        message: "",
    });

    const { loading } = useLoading();

    const handleHtml = () => {
        return `
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <style>
                            h3 {
                                color: #38733e;
                            }
    
                            p {
                                color: black;
                            }
                        </style>
                    </head>
                    <body>
                        <div>
                            <h3>Cliente</h3>
                            <p>${client.Nome}</p>
                        </div>
                        <div>
                            <h3>Mensagem</h3>
                            <p>
                                ${data.message}
                            </p>
                        </div>
                    </body>
                </html>`;
    };

    async function handleSubmit(e) {
        e.preventDefault();

        const idLoading = loading();
        try {
            if (!data.subject) {
                loading(idLoading);

                return notification("warning", "Assunto é obrigatório");
            }

            if (!data.message) {
                loading(idLoading);

                return notification("warning", "Mensagem é obrigatório");
            }

            await api.post(
                "/email",
                {
                    to: main.inputs,
                    subject: data.subject,
                    html: handleHtml(),
                },
                publicRequest
            );

            setData({
                subject: "",
                message: "",
            });

            notification("success", "Mensagem enviada");

            loading(idLoading);
        } catch (error) {
            notificationError(error);

            loading(idLoading);
        }
    }

    function handleOnChange({ target }) {
        const { name, value } = target;

        setData({ ...data, [name]: value });
    }

    return { data, handleSubmit, handleOnChange };
}

export default useContact;
